import { render, staticRenderFns } from "./cutoff-edit-modal.vue?vue&type=template&id=c96d23f2"
import script from "./cutoff-edit-modal.vue?vue&type=script&lang=js"
export * from "./cutoff-edit-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports